import { useEffect } from "react";
import { startWarmReportPdfFunctions } from "../../actions/reportPdf";
import { useDispatchApp } from "../../lib/redux";

const useWarmReportPdfFunctions = (enabled = true) => {
  const dispatch = useDispatchApp();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    dispatch(startWarmReportPdfFunctions());
  }, [dispatch, enabled]);
};

export default useWarmReportPdfFunctions;
